import { gql } from "@apollo/client";

const CREATE_SUBSCRIPTION = gql`
  mutation CreateSubscription($input: CreateSubscriptionInput!) {
    createSubscription(input: $input) {
      subscription {
        status
        endDate
        metaData
        stripeLatestInvoiceId
      }
    }
  }
`;

export default CREATE_SUBSCRIPTION;
